import { render, staticRenderFns } from "./merchandise.html?vue&type=template&id=54ad2a72&scoped=true&"
import script from "./merchandise.js?vue&type=script&lang=js&"
export * from "./merchandise.js?vue&type=script&lang=js&"
import style0 from "./merchandise.css?vue&type=style&index=0&id=54ad2a72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ad2a72",
  null
  
)

export default component.exports